export default {
  primaryColor: '#fff',
  secondaryColor: '#7558f4',
  blackColor: '#1e1e28',
  blackLightColor: '#5c5c6f',
  grey500Color: '#8c8c8e',
  grey300Color: '#c0c0ca',
  greyBackground: '#f4f4f6',
  greyContainer: '#e0e0e6',
};
